import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stat } from 'fs';

export interface ContactInfoState {
  loading: boolean;
  displayBusinessName: string | null;
  contactDetails: any | null;
  addressDetails: any | null;
  phoneDetails: any | null;
  emailDetails: any | null;
  statementPref: any | null;
  updateAddressDetails: any | null;
  updatePhoneDetails: any | null;
  updateEmailDetails: any | null;
  updatePreferredLang: any | null;
  updateStatementPref: any | null;
  error: any | null;
  optionError: any | null;
  secureMessage: any | null;
  updateSecureMessage: any | null;
  updateSecureMessageError: any | null;
  secureMessageDetails: any | null;
  secureMessageDetailsLoading: boolean;
  secureMessageDetailsError: any | null;
  secureMessageOptions: any | null;
  secureMessageOptionsLoading : boolean;
  secureMessageLoading: boolean;
  secureMessageError: any | null;
  secureMessageOptionsError: any | null;
}

const initialState: ContactInfoState = {
  loading: false,
  displayBusinessName: null,
  contactDetails: null,
  addressDetails: null,
  phoneDetails: null,
  emailDetails: null,
  statementPref: null,
  updateAddressDetails: null,
  updatePhoneDetails: null,
  updateEmailDetails: null,
  updatePreferredLang: null,
  updateStatementPref: null,
  error: null,
  optionError: null,
  secureMessage: null,
  updateSecureMessage: null,
  updateSecureMessageError: null,
  secureMessageDetails: null,
  secureMessageDetailsLoading: false,
  secureMessageDetailsError: null,
  secureMessageOptions: null,
  secureMessageOptionsLoading: false,
  secureMessageLoading: false,
  secureMessageError: null,
  secureMessageOptionsError: null,
};

const contactInfoSlice = createSlice({
  name: 'contactInfo',
  initialState,
  reducers: {
    displayBusinessNameRequest(state, action) {
      state.displayBusinessName = null;
    },
    displayBusinessNameFetched(state, action) {
      state.displayBusinessName = action.payload;
    },
    displayBusinessNameFetchFailed(state, action) {
      state.displayBusinessName = null;
    },
    contactInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
      state.updateAddressDetails = null;
      state.updatePhoneDetails = null;
      state.updateEmailDetails = null;
      state.updatePreferredLang = null;
    },
    contactInfoFetched(state, action) {
      state.loading = false;
      state.contactDetails = action.payload;
      state.error = null;
    },
    contactInfoFetchFailed(state, action) {
      state.loading = false;
      state.contactDetails = null;
      state.error = action.payload;
    },
    addressInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.optionError = null;
    },
    addressInfoFetched(state, action) {
      state.loading = false;
      state.addressDetails = action.payload;
      state.optionError = null;
    },
    addressInfoFetchFailed(state, action) {
      state.loading = false;
      state.addressDetails = null;
      state.optionError = action.payload;
    },
    updateAddressInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    updateAddressInfoFetched(state, action) {
      state.loading = false;
      state.updateAddressDetails = action.payload;
      state.error = null;
    },
    updateAddressInfoFetchFailed(state, action) {
      state.loading = false;
      // state.addressDetails = null;
      state.error = action.payload;
    },
    phoneInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.optionError = null;
    },
    phoneInfoFetched(state, action) {
      state.loading = false;
      state.phoneDetails = action.payload;
      state.optionError = null;
    },
    phoneInfoFetchFailed(state, action) {
      state.loading = false;
      state.phoneDetails = null;
      state.optionError = action.payload;
    },
    updatePhoneInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    updatePhoneInfoFetched(state, action) {
      state.loading = false;
      state.updatePhoneDetails = action.payload;
      state.error = null;
    },
    updatePhoneInfoFetchFailed(state, action) {
      state.loading = false;
      // state.phoneDetails = null;
      state.error = action.payload;
    },
    emailInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.optionError = null;
    },
    emailInfoFetched(state, action) {
      state.loading = false;
      state.emailDetails = action.payload;
      state.optionError = null;
    },
    emailInfoFetchFailed(state, action) {
      state.loading = false;
      state.emailDetails = null;
      state.optionError = action.payload;
    },
    updateEmailInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    updateEmailInfoFetched(state, action) {
      state.loading = false;
      state.updateEmailDetails = action.payload;
      state.error = null;
    },
    updateEmailInfoFetchFailed(state, action) {
      state.loading = false;
      state.emailDetails = null;
      state.error = action.payload;
    },
    updatePreferredLangInfoRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    updatePreferredLangInfoFetched(state, action) {
      state.loading = false;
      state.updatePreferredLang = action.payload;
      state.error = null;
    },
    updatePreferredLangInfoFetchFailed(state, action) {
      state.loading = false;
      state.emailDetails = null;
      state.error = action.payload;
    },
    statementPrefRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.optionError = null;
      state.updateStatementPref = null;
    },
    statementPrefFetched(state, action) {
      state.loading = false;
      state.statementPref = action.payload;
      state.optionError = null;
    },
    statementPrefFetchFailed(state, action) {
      state.loading = false;
      state.statementPref = null;
      state.optionError = action.payload;
    },
    updateStatementPrefRequest(state, action) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    updateStatementPrefFetched(state, action) {
      state.loading = false;
      state.updateStatementPref = action.payload;
      state.error = null;
    },
    updateStatementPrefFetchFailed(state, action) {
      state.loading = false;
      state.updateStatementPref = null;
      state.error = action.payload;
    },
    secureMessageRequest(state, action) {
      state.secureMessage = null;
      state.secureMessageError = null;
      state.secureMessageLoading = true;
    },
    secureMessageFetched(state, action) {
      state.secureMessage = action.payload?.cases || action.payload || [];
      state.secureMessageError = null;
      state.secureMessageLoading = false;
    },
    secureMessageFetchFailed(state, action) {
      state.secureMessage = null;
      state.secureMessageError = action.payload;
      state.secureMessageLoading = false;
    },
    // for details
    secureMessageDetailsRequest(state, action) {
      state.secureMessageDetails = null;
      state.secureMessageDetailsError = null;
      state.secureMessageDetailsLoading = true;
    },
    secureMessageDetailsFetched(state, action) {
      state.secureMessageDetails = action.payload;
      state.secureMessageDetailsError = null;
      state.secureMessageDetailsLoading = false;
    },
    secureMessageDetailsFetchFailed(state, action) {
      state.secureMessageDetails = null;
      state.secureMessageDetailsError = action.payload;
      state.secureMessageDetailsLoading = false;
    },
    secureMessageOptionsRequest(state, action) {
      state.secureMessageOptions = null;
      state.secureMessageOptionsError = null;
      state.secureMessageOptionsLoading = true;
    },
    secureMessageOptionsFetched(state, action) {
      state.secureMessageOptions = action.payload;
      state.secureMessageOptionsError = null;
      state.secureMessageOptionsLoading = false;
    },
    secureMessageOptionsFetchFailed(state, action) {
      state.secureMessageOptions = null;
      state.secureMessageOptionsError = action.payload;
      state.secureMessageOptionsLoading = false;
    },
    updateSecureMessageRequest(state, action) {
      state.updateSecureMessage = null;
      state.updateSecureMessageError = null;
      state.secureMessageLoading = true;
    },
    updateSecureMessageFetched(state, action) {
      state.updateSecureMessage = action.payload;
      state.updateSecureMessageError = null;
      state.secureMessageLoading = false;
    },
    updateSecureMessageFetchFailed(state, action) {
      state.updateSecureMessage = null;
      state.updateSecureMessageError = action.payload;
      state.secureMessageLoading = false;
       state.secureMessageOptionsError = null;
    },
    updateSecureMessageState(state, action) {
      state.updateSecureMessage = null;
    },
    resetContactInfoError(state) {
      state.optionError = null;
      state.error = null;
    },
    resetContactInfoSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  displayBusinessNameRequest,
  displayBusinessNameFetched,
  displayBusinessNameFetchFailed,
  contactInfoRequest,
  contactInfoFetched,
  contactInfoFetchFailed,
  addressInfoRequest,
  addressInfoFetched,
  addressInfoFetchFailed,
  phoneInfoRequest,
  phoneInfoFetched,
  phoneInfoFetchFailed,
  emailInfoRequest,
  emailInfoFetched,
  emailInfoFetchFailed,
  updateAddressInfoRequest,
  updateAddressInfoFetched,
  updateAddressInfoFetchFailed,
  updatePhoneInfoRequest,
  updatePhoneInfoFetched,
  updatePhoneInfoFetchFailed,
  updateEmailInfoRequest,
  updateEmailInfoFetched,
  updateEmailInfoFetchFailed,
  updatePreferredLangInfoRequest,
  updatePreferredLangInfoFetched,
  updatePreferredLangInfoFetchFailed,
  statementPrefRequest,
  statementPrefFetched,
  statementPrefFetchFailed,
  updateStatementPrefRequest,
  updateStatementPrefFetched,
  updateStatementPrefFetchFailed,
  secureMessageRequest,
  secureMessageFetched,
  secureMessageFetchFailed,
  secureMessageDetailsRequest,
  secureMessageDetailsFetched,
  secureMessageDetailsFetchFailed,
  secureMessageOptionsRequest,
  secureMessageOptionsFetched,
  secureMessageOptionsFetchFailed,
  updateSecureMessageRequest,
  updateSecureMessageFetched,
  updateSecureMessageFetchFailed,
  updateSecureMessageState,
  resetContactInfoError,
  resetContactInfoSlice,
} = contactInfoSlice.actions;

export default contactInfoSlice.reducer;
